import { render, staticRenderFns } from "./CreditCardNeeded.vue?vue&type=template&id=0aaffab5"
import script from "./CreditCardNeeded.vue?vue&type=script&lang=js"
export * from "./CreditCardNeeded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports